import { Injectable } from '@angular/core';
import { Database, ref, push, set, get } from '@angular/fire/database';
import { InterestedPassenger } from '../models/passenger.model';

@Injectable({
  providedIn: 'root'
})
export class PassengerService {

  constructor(private database: Database) { }

  /**
   * Save a new interested passenger to Firebase Realtime Database
   */
  async saveInterestedPassenger(passengerData: InterestedPassenger): Promise<string> {
    try {
      const passengersRef = ref(this.database, 'interestedPassengers');
      const newPassengerRef = push(passengersRef);
      
      await set(newPassengerRef, passengerData);
      
      return newPassengerRef.key!; // Returns the generated ID
    } catch (error) {
      console.error('Error saving passenger data:', error);
      throw error;
    }
  }

  /**
   * Get all interested passengers
   */
  async getAllInterestedPassengers(): Promise<any> {
    try {
      const passengersRef = ref(this.database, 'interestedPassengers');
      const snapshot = await get(passengersRef);
      
      if (snapshot.exists()) {
        return snapshot.val();
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting passengers data:', error);
      throw error;
    }
  }

  /**
   * Get a specific passenger by ID
   */
  async getPassengerById(passengerId: string): Promise<InterestedPassenger | null> {
    try {
      const passengerRef = ref(this.database, `interestedPassengers/${passengerId}`);
      const snapshot = await get(passengerRef);
      
      if (snapshot.exists()) {
        return snapshot.val() as InterestedPassenger;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error getting passenger data:', error);
      throw error;
    }
  }
}
